import React, { memo } from 'react';
import DispexButton from '../../../../../components/DispexButton/DispexButton';
import styles from '../modalStyles.module.scss';

const FooterButtons = ({
  disabled,
  okButtonText,
  onOk,
  onCancel,
  onDelete,
  deleteButtonText,
  showDelete,
}) => {
  return (
    <div className={styles.buttons}>
      <div>
        <DispexButton type="default" onClick={onCancel} disabled={disabled}>
          Отмена
        </DispexButton>
        <DispexButton type="primary" onClick={onOk} disabled={disabled}>
          {okButtonText || 'Сохранить'}
        </DispexButton>
      </div>
      {!!showDelete && (
        <DispexButton type="danger" onClick={onDelete} disabled={disabled}>
          {deleteButtonText || 'Удалить'}
        </DispexButton>
      )}
    </div>
  );
};

export default memo(FooterButtons);
